import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import FormControl from "@mui/material/FormControl";
import { useMediaQuery } from "@mui/material";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  FormHelperText,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import {
  ApplyFiltersProduct,
  GetActiveProduct,
} from "../../../services/admin/adminServices";
import { CODES } from "../../../consts/codes";
import { useSelector } from "react-redux";
import { getUser } from "../../../pages/userSlice";
import { REGEXP } from "../../../consts/regexp";

/**
 * Const
 */
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const FilterDynamicReport = ({
  control,
  formState: { errors },
  emailList,
  setEmailList,
  getValues,
  setValue,
  selectAllItem,
}) => {
  /**
   * t of useTranslation to translate
   */
  const { t } = useTranslation();

  const [txtSeparatorsList, setTxtSeparatorsList] = useState([]);
  const [emailListError, setEmailListError] = useState(false);

  /**
   * Info of the user who logs into the website
   */
  const userInfo = useSelector(getUser);

  /**
   * filterOptions para el autocomplete de compañías
   */
  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 200,
  });

  /**
   *
   * Función que se acciona cuando se cambia el valor del autocomplete de NRPs para cambiar el valor del state de nrpsSelected que es lo que se muestra seleccionado en el autcomplete
   * También funciona para seleccionar todos los valores cuando se selecciona la opción de 'Seleccionar todos'
   *
   * @param {Event} event
   * @param {Values} values lista
   * @param {String} reason tipo de selección; selectOption, removeOption
   * @param {Object} detail opción elegida
   */
  const onEmailListChange = (event, values, reason, detail) => {
    const option = detail?.option ?? null;
    values = values.filter((item) => item.value !== selectAllItem.value);

    if (reason === "removeOption" && option?.value === selectAllItem.value) {
      values = [];
    } else if (
      reason === "selectOption" &&
      option?.value === selectAllItem.value
    ) {
      values = emailList;
    }

    return values.length === emailList.length - 1
      ? [...values, selectAllItem]
      : values;
  };

  /**
   * usEffect to fetch active products and role list for the states of activeProducts and emailList
   */
  useEffect(() => {
    /**
     * Function to get the list of active products and set the data in state of activeProducts
     */
    async function handleTxtSeparators() {
      try {
        const obj = {
          eanCompany: userInfo?.company?.eanCompany,
          country: userInfo?.company?.country,
        };

        const activeProductsService = await ApplyFiltersProduct(obj);

        if (
          activeProductsService.status === CODES.COD_RESPONSE_HTTP_OK &&
          activeProductsService.data.responseCode ===
            CODES.COD_RESPONSE_SUCCESS_REQUEST
        ) {
          // const separatorsList = activeProductsService.data.responseMessage.map(
          //   (product) => {
          //     return {
          //       label: product.menuOptionName,
          //       value: product.idMenuOption,
          //     };
          //   }
          // );

          const separatorsList = [
            {
              label: "Tabulador",
              value: "Tabulador",
            },
            {
              label: "Punto y coma",
              value: "Punto y coma",
            },
            {
              label: "Pipe",
              value: "Pipe",
            },
            {
              label: "Coma",
              value: "Coma",
            },
          ];

          setTxtSeparatorsList(separatorsList);
        }
      } catch (error) {
        console.log("====================================");
        console.log(error);
        console.log("====================================");
      }
    }

    handleTxtSeparators();
  }, [userInfo]);

  /**
   *
   * Add and select an email
   *
   * @param {String} email email to add
   */
  const handlerAddEmail = (email) => {
    const emailExists = emailList.find((item) => item.value === email);
    if (!emailExists) {
      const emailObj = { label: email, value: email };
      setEmailList([...emailList, emailObj]);
      setValue("emailList", [...getValues("emailList"), emailObj]);
    }
  };

  return (
    <Accordion defaultExpanded={true} expanded={true} disableGutters>
      <Grid item className="">
        <AccordionSummary aria-controls="panel2a-content" id="panel2a-header">
          <TuneOutlinedIcon
            sx={{
              fontSize: 20,
              color: "#543ab4",
            }}
          />
          <p className="navbar__text" style={{ paddingLeft: "1rem" }}>
            {t("App.infonavitDynamicReport.filterName")}
          </p>
        </AccordionSummary>
      </Grid>

      <AccordionDetails>
        <Grid container alignItems="center" gap={3}>
          {/* -----------  Txt limitado por ------------    */}
          <Grid item xs={12} sm={12} md lg xl>
            <label className="form__label label__text-grey">
              {t("App.infonavitDynamicReport.filterFields.txtSeparator")}
            </label>

            <Controller
              className="select__filters"
              defaultValue="2"
              control={control}
              name="txtSeparator"
              render={({ field: { onChange, value } }) => (
                <>
                  <Select
                    inputProps={{
                      style: {
                        margin: "-5px 0 0 0 !important",
                        fontSize: 12,
                        border: "1px solid !important",
                      },
                    }}
                    value={value}
                    displayEmpty
                    className={
                      errors.txtSeparator
                        ? "select__filters__full select__filters__errors"
                        : "select__filters__full"
                    }
                    onChange={onChange}
                  >
                    <MenuItem value="">
                      <em>{t("App.createUser.selectOption")}</em>
                    </MenuItem>

                    {txtSeparatorsList.map((separator) => (
                      <MenuItem
                        key={separator.value}
                        name={separator.label}
                        value={separator.value}
                      >
                        {separator.label}
                      </MenuItem>
                    ))}
                  </Select>

                  <FormHelperText
                    className="form_helper_text"
                    error={!!errors.txtSeparator}
                  >
                    {errors.txtSeparator ? errors.txtSeparator.message : ""}
                  </FormHelperText>
                </>
              )}
            />
          </Grid>

          {/* -------- LISTA DE CORREOS -------  */}
          <Grid item xs={12} sm={12} md lg xl>
            <label className="form__label label__text-grey">
              {t("App.infonavitDynamicReport.filterFields.emailList")}
            </label>

            <Controller
              name="emailList"
              render={({ field: { onChange, value } }) => (
                <Autocomplete
                  noOptionsText={t(
                    "App.infonavitDynamicReport.filterFields.emailListTip"
                  )}
                  className={
                    errors.emailList || emailListError
                      ? "select__filters__full select__filters__errors"
                      : "select__filters__full"
                  }
                  options={emailList}
                  value={value || []}
                  multiple
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  filterOptions={filterOptions}
                  disableCloseOnSelect
                  limitTags={1}
                  onChange={(event, values, reason, detail) => {
                    onChange(onEmailListChange(event, values, reason, detail));
                  }}
                  getOptionLabel={(option) => option.label}
                  renderOption={(props, option, { selected }) => (
                    <li key={option.label} {...props}>
                      <Checkbox
                        icon={icon}
                        className="autoComplete__checkbox"
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.label}
                    </li>
                  )}
                  renderInput={(params) => {
                    return (
                      <TextField
                        placeholder={t(
                          "App.infonavitDynamicReport.filterFields.emailListPlaceholder"
                        )}
                        {...params}
                        helperText={
                          errors.emailList ? errors.emailList.message : ""
                        }
                        error={!!errors.emailList}
                        onKeyDown={(e) => {
                          setEmailListError(false);

                          if (e.key === "Enter") {
                            e.preventDefault();

                            if (REGEXP.EMAIL.test(e.target.value))
                              handlerAddEmail(e.target.value);
                            else setEmailListError(true);
                          }
                        }}
                      />
                    );
                  }}
                  renderTags={(values) => {
                    const size = values.filter(
                      (item) => item.value !== selectAllItem.value
                    ).length;
                    const label =
                      size > 1
                        ? t("App.autocomplete.selected")
                        : t("App.autocomplete.oneSelected");

                    return (
                      <Chip
                        label={`${size} ${label}`}
                        className="autocomplete-chip"
                        variant="filled"
                      />
                    );
                  }}
                />
              )}
              control={control}
            />
          </Grid>

          {/* -----------  PERIODICIDAD ------------    */}
          <Grid item xs={12} sm={12} md lg xl>
            <label className="form__label label__text-grey">
              {t("App.infonavitDynamicReport.filterFields.daysFrequency")}
            </label>

            <Controller
              name="daysFrequency"
              control={control}
              render={({ field: { onChange, value } }) => (
                <TextField
                  onChange={onChange}
                  value={value}
                  type="text"
                  placeholder={t(
                    "App.infonavitDynamicReport.filterFields.daysFrequencyPlaceholder"
                  )}
                  inputProps={{
                    style: {
                      margin: "-5px 0 0 0 !important",
                      fontSize: 12,
                      border: "1px solid !important",
                    },
                    maxLength: "3",
                  }}
                  helperText={
                    errors.daysFrequency ? errors.daysFrequency.message : ""
                  }
                  error={!!errors.daysFrequency}
                  className={
                    errors.daysFrequency
                      ? "select__filters__full select__filters__errors"
                      : "select__filters__full"
                  }
                />
              )}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
